// import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from "react-toastify";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import { Amplify } from "aws-amplify";
import PropTypes from "prop-types";
import Home from "./components/Home";
import Property from "./components/property/Property";
import PropertyProvider from "./data/PropertyHook";
import Nav from "./components/Nav";
import { clearTemporaryValues } from "./data/TemporaryInsecureStore";
import WorkOrder from "./components/workOrder/WorkOrder";
import "bootstrap/dist/css/bootstrap.min.css";
import BreadcrumbProvider from "./data/BreadcrumbHook";
import WorkOrdersProvider from "./data/WorkOrdersHook";
import WorkItem from "./components/workItem/WorkItem";
import Error from "./components/Error";
import EmbeddedError from "./components/EmbeddedError";
import WorkOrderCreate from "./components/workOrder/WorkOrderCreate";
import WorkItemTemplatesProvider from "./data/WorkItemTemplatesHook";
import AppointmentSlotProvider from "./data/AppointmentSlotHook";
import WorkItemAgreementsProvider from "./data/WorkItemAgreementsHook";
import WorkItemCategoriesProvider from "./data/WorkItemCategoriesHook";
import TypeOfWorkProvider from "./data/TypeOfWorkHook";
import CategoriesProvider from "./data/CategoriesHook";
import SubCategoriesProvider from "./data/SubCategoriesHook";
import AssetsProvider from "./data/AssetsHook";
import SlaProvider from "./data/SlaHook";
import ReporterTypeProvider from "./data/ReporterTypeHook";
import ContractInfoProvider from "./data/ContractInfoHook";
import WorkOrderUpdate from "./components/workOrder/WorkOrderUpdate";
import WorkItemUpdate from "./components/workItem/WorkItemUpdate";
import WorkItemRemake from "./components/workItem/WorkItemRemake";
import WorkItemsProvider from "./data/WorkItemHook";
import WorkItemCreate from "./components/workItem/WorkItemCreate";
import ProjectsProvider from "./data/ProjectsHook";
import AuthProvider from "./data/AuthHook";
import { config } from "./util/Amplify";
import EngineerAvailabilityProvider from "./data/EngineerAvailability";
import Footer from "./components/Footer";

Amplify.configure(config);

function ErrorFallback({ resetErrorBoundary }) {
  return <Error resetErrorBoundary={resetErrorBoundary} />;
}

ErrorFallback.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
};

function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        clearTemporaryValues();
      }}
    >
      <div className="App">
        <AuthProvider>
          <BreadcrumbProvider>
            <PropertyProvider>
              <WorkOrdersProvider>
                <WorkItemsProvider>
                  <WorkItemTemplatesProvider>
                    <ProjectsProvider>
                      <AppointmentSlotProvider>
                        <WorkItemAgreementsProvider>
                          <WorkItemCategoriesProvider>
                            <TypeOfWorkProvider>
                              <CategoriesProvider>
                                <SubCategoriesProvider>
                                  <AssetsProvider>
                                    <SlaProvider>
                                      <ReporterTypeProvider>
                                        <ContractInfoProvider>
                                          <EngineerAvailabilityProvider>
                                            <Nav />
                                            <Routes>
                                              <Route
                                                path="/"
                                                element={<Home />}
                                              />
                                              <Route
                                                path="/property/:propertyId"
                                                element={<Property />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/create"
                                                element={<WorkOrderCreate />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/:workOrderId"
                                                element={<WorkOrder />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/:workOrderId/update"
                                                element={<WorkOrderUpdate />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/:workOrderId/workitem/:workItemId"
                                                element={<WorkItem />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/:workOrderId/workitem/create"
                                                element={<WorkItemCreate />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/:workOrderId/workitem/:workItemId/update"
                                                element={<WorkItemUpdate />}
                                              />
                                              <Route
                                                path="/property/:propertyId/workorder/:workOrderId/workitem/:workItemId/remake"
                                                element={<WorkItemRemake />}
                                              />
                                              <Route
                                                path="/error"
                                                element={<EmbeddedError />}
                                              />
                                            </Routes>
                                            <Footer />
                                            <ToastContainer position="bottom-center" />
                                          </EngineerAvailabilityProvider>
                                        </ContractInfoProvider>
                                      </ReporterTypeProvider>
                                    </SlaProvider>
                                  </AssetsProvider>
                                </SubCategoriesProvider>
                              </CategoriesProvider>
                            </TypeOfWorkProvider>
                          </WorkItemCategoriesProvider>
                        </WorkItemAgreementsProvider>
                      </AppointmentSlotProvider>
                    </ProjectsProvider>
                  </WorkItemTemplatesProvider>
                </WorkItemsProvider>
              </WorkOrdersProvider>
            </PropertyProvider>
          </BreadcrumbProvider>
        </AuthProvider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
